import React from "react";
import Component from "../../Components";

const Ambulance = () => {
  return (
    <div>
      <Component.ManageAmbulanceList />
    </div>
  );
};

export default Ambulance;
